import React from "react"
import autobind from "class-autobind"
import strings from "../../../../localization/strings"
import { Toggle, DatePicker, RaisedButton } from "material-ui"
import { IDate, IPayrollItemForAccountLevel, IHierarchyItem } from "../../../../models"
import moment from "moment"
import AppStateStore from "../../../../stores/AppStateStore"
import * as punchActions from "../../../../actions/PunchActions"
import * as payrollHelper from "../../../../helpers/payrollHelper"
import MultiPayrollHierarchyChips from "../../../../components/payroll/MultiPayrollHierarchyChips"
import { red500 } from "material-ui/styles/colors"

interface IProps {
}
interface IState {
    recalc: boolean
    referenceDate: IDate
    excludeInactiveEmployees: boolean
    byPayroll: boolean
    selectedPayrollHierarchyIds: string[]
}

export default class RecalcTimecards extends React.Component<IProps, IState> {
    private payrollHierarchyItems: (IPayrollItemForAccountLevel | IHierarchyItem)[]
    constructor(props: IProps) {
        super(props)
        this.payrollHierarchyItems = payrollHelper.getSelectablePayrollHierarchyItems()
        this.state = {
            recalc: false,
            referenceDate: null,
            excludeInactiveEmployees: true,
            byPayroll: false,
            selectedPayrollHierarchyIds: []
        }
        autobind(this)
    }

    render() {
        return (
            <div>
                <Toggle
                    toggled={!this.state.recalc}
                    onToggle={() => this.setState({ recalc: !this.state.recalc })}
                    labelPosition="left"
                    label={strings.Recache_Timecards}
                    style={{ maxWidth: 275 }}
                />
                <Toggle
                    toggled={this.state.recalc}
                    onToggle={() => this.setState({ recalc: !this.state.recalc })}
                    labelPosition="left"
                    label={strings.Recalculate_Timecards}
                    style={{ maxWidth: 275 }}
                />
                <DatePicker
                    floatingLabelText={strings.Date}
                    value={this.state.referenceDate}
                    onChange={(e, referenceDate) => this.setState({ referenceDate })}
                    errorText={!this.state.referenceDate && strings.This_field_is_required}
                    style={{ marginBottom: 10 }}
                />
                <div style={{ display: "flex", height: 50 }}>
                    <Toggle
                        toggled={this.state.excludeInactiveEmployees}
                        onToggle={() => this.setState({ excludeInactiveEmployees: !this.state.excludeInactiveEmployees })}
                        labelPosition="left"
                        label={strings.Exclude_Inactive_Employees}
                        style={{ maxWidth: 275 }}
                    />
                    <span style={{ color: red500, fontSize: 12, marginLeft: 20, display: !this.state.excludeInactiveEmployees && "none" }}>
                        *If an employee is inactive, timecards will not be recached/recalculated, even if the employee still has a timecard for the selected date.
                    </span>
                </div>
                {this.payrollHierarchyItems.length > 1 &&
                    <div>
                        <Toggle
                            toggled={this.state.byPayroll}
                            onToggle={() => this.setState({ byPayroll: !this.state.byPayroll })}
                            labelPosition="left"
                            label={strings.Select_Payroll_Hierarchy}
                            style={{ maxWidth: 275 }}
                        />
                        {this.state.byPayroll &&
                            <MultiPayrollHierarchyChips
                                selectedPayrollHierarchyIds={this.state.selectedPayrollHierarchyIds}
                                handleChange={selectedPayrollHierarchyIds => this.setState({ selectedPayrollHierarchyIds })}
                            />
                        }
                    </div>
                }
                <RaisedButton
                    secondary
                    label={strings.Proceed}
                    style={{ marginTop: 10 }}
                    disabled={(this.state.referenceDate ? false : true) || (this.state.byPayroll && this.state.selectedPayrollHierarchyIds.length < 1 ? true : false)}
                    onClick={() => {
                        const referenceDateStr = moment(this.state.referenceDate).format("YYYY-MM-DD")
                        AppStateStore.setConfirmDialogContent({
                            content: strings.formatString(this.state.recalc ?
                                strings.Are_you_sure_you_want_to_recalculate_timecards_at_x :
                                strings.Are_you_sure_you_want_to_recache_timecards_at_x,
                                referenceDateStr
                            ) as string,
                            confirm: async () => {
                                AppStateStore.setProgressSnackbarContent("loading")
                                await punchActions.recalcRecacheTimecards(
                                    this.state.recalc,
                                    moment(this.state.referenceDate).utc(true).format(),
                                    !this.state.byPayroll,
                                    this.state.excludeInactiveEmployees,
                                    this.state.byPayroll ? this.state.selectedPayrollHierarchyIds : []
                                )
                                AppStateStore.setProgressSnackbarContent(null)
                            }
                        })
                    }}
                />
            </div>
        )
    }
}